/** Chave pública do reCAPTCHA v3 do board (RQ-ACE-017); o segredo fica só no servidor. */
const CHAVE_BOARD = '6LdGfgAuAAAAAPGOglMypJl8uEfLrNxT6J3LcUiC';

type Grecaptcha = { ready(f: () => void): void; execute(chave: string, opcoes: { action: string }): Promise<string> };

let carregando: Promise<Grecaptcha> | null = null;

function carregar(): Promise<Grecaptcha> {
  carregando ??= new Promise<Grecaptcha>((ok, falha) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${CHAVE_BOARD}`;
    script.async = true;
    script.onload = () => {
      const g = (window as unknown as { grecaptcha: Grecaptcha }).grecaptcha;
      g.ready(() => ok(g));
    };
    script.onerror = () => {
      carregando = null;
      falha(new Error('reCAPTCHA indisponível'));
    };
    document.head.appendChild(script);
  });
  return carregando;
}

/**
 * Token silencioso para a ação. Sem o Google (bloqueador, rede), devolve vazio: a API decide
 * (com o Google fora do ar para ela também, o login segue; com o Google no ar, recusa).
 */
export async function tokenRecaptcha(acao: string): Promise<string> {
  try {
    return await (await carregar()).execute(CHAVE_BOARD, { action: acao });
  } catch {
    return '';
  }
}

/** Carrega o script antes do clique em Entrar, para o login não esperar o Google. */
export function prepararRecaptcha() {
  carregar().catch(() => undefined);
}
